import { useState } from 'react';
import { AuditTimeline, AuditTimelineProps, AuditLog } from './AuditTimeline';
import { AuditDetailsModal } from './AuditDetailsModal';
import { Box, Typography } from '@mui/material';
import { useGetList } from 'react-admin';

/**
 * Compact version of AuditTimeline for use in modals or limited space
 * Enhanced with clickable items that open a details modal
 */
export const AuditTimelineCompact = (props: Omit<AuditTimelineProps, 'compact'>) => {
  const [selectedLog, setSelectedLog] = useState<AuditLog | null>(null);
  const [modalOpen, setModalOpen] = useState(false);

  const { resourceType, resourceId, limit = 5 } = props;

  // Get audit logs to make them clickable
  const resourceIdString = resourceId ? String(resourceId) : '';
  const resourceIdNumber = resourceId ? Number(resourceId) : NaN;
  
  const isValidResourceId = 
    resourceId && 
    resourceIdString !== 'create' && 
    resourceIdString !== '' &&
    !isNaN(resourceIdNumber) && 
    resourceIdNumber > 0 && 
    Number.isInteger(resourceIdNumber);

  const { data: logs = [] } = useGetList<AuditLog>(
    'audit',
    {
      pagination: { page: 1, perPage: limit },
      sort: { field: 'createdAt', order: 'DESC' },
      filter: { resourceType, resourceId: resourceIdNumber },
    },
    { enabled: isValidResourceId }
  );

  const handleLogClick = (log: AuditLog) => {
    setSelectedLog(log);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedLog(null);
  };

  return (
    <>
      <AuditTimeline {...props} compact={true} limit={limit} onLogClick={handleLogClick} />
      {logs.length > limit && (
        <Box mt={1}>
          <Typography variant="caption" color="text.secondary">
            Mostrando {limit} de {logs.length} registros. Clique em um item para ver detalhes.
          </Typography>
        </Box>
      )}
      <AuditDetailsModal log={selectedLog} open={modalOpen} onClose={handleCloseModal} />
    </>
  );
};

